module.exports = __webpack_public_path__ + "img/virtual-reality-dark.a34ae9b7.svg";